module.exports = __webpack_public_path__ + "static/media/carousel.45fdd050.jpg";